import { Map } from 'immutable'

/**
 * @param {ReduxState} state redux state
 * @returns {Map}
 */
export function selectOracle (state) {
  return state.oracle || Map()
}

/**
 * @param {ReduxState} state redux state
 * @returns {Map}
 */
export function selectOracleAccess (state) {
  return selectOracle(state).get('access', Map())
}

/**
 * @param {ReduxState} state redux state
 * @returns {Boolean}
 */
export function selectHasVoiceAccess (state) {
  const access = selectOracleAccess(state)
  return access.get('aiSpeech', false)
}

/**
 * @param {ReduxState} state redux state
 * @returns {Boolean}
 */
export function selectHasUnlimitedChat (state) {
  const access = selectOracleAccess(state)
  return access.get('aiTextUnlimited', false)
}

/**
 * @param {ReduxState} state redux state
 * @returns {Boolean}
 */
export function selectOracleAccessProcessing (state) {
  return selectOracle(state).get('accessProcessing', false)
}

/**
 * @param {ReduxState} state redux state
 * @returns {boolean} true if guide is closed, false if open
 */
export function selectOracleGuideOnSideClosed (state) {
  return selectOracle(state).get('guideOnSideClosed', false)
}

// TODO: Future - pin/unpin functionality (commented for v1)
// /**
//  * @param {ReduxState} state redux state
//  * @returns {string} One of: 'closed', 'unpinned', 'pinned'
//  */
// export function selectOracleGuideOnSideState (state) {
//   return selectOracle(state).get('guideOnSideState', 'unpinned')
// }
